export default __webpack_public_path__ + "static/media/نفیسه باقری.bdad7a08.jpeg";